import { useCallback } from 'react';
import { EventType, useEventBus } from 'context';
import { SUPER_SEARCH_COMMANDS } from './SuperSearch.constants';
import type { SuperSearchDisplayItem } from './SuperSearch.types';

interface UseSuperSearchActionsOptions {
  onClose: () => void;
  onNavigate: (item: SuperSearchDisplayItem) => void;
  onScopeItem: (item: SuperSearchDisplayItem) => boolean;
  onStartTour: (tourId: string) => void;
}

const useSuperSearchActions = ({ onClose, onNavigate, onScopeItem, onStartTour }: UseSuperSearchActionsOptions) => {
  const { publish } = useEventBus();

  return useCallback(
    (item: SuperSearchDisplayItem) => {
      if (item.kind === 'company-page-command' || item.kind === 'firm-page-command') {
        onScopeItem(item);
        return;
      }

      switch (item.command) {
        case SUPER_SEARCH_COMMANDS.CREATE_COMPANY:
          onClose();
          publish(EventType.OPEN_CREATE_COMPANY_DIALOG, undefined);
          return;
        case SUPER_SEARCH_COMMANDS.CREATE_MEASUREMENT_DATE:
          onClose();
          publish(EventType.OPEN_CREATE_MEASUREMENT_DATE_DIALOG, undefined);
          return;
        case SUPER_SEARCH_COMMANDS.OPEN_NOTIFICATIONS:
          onClose();
          publish(EventType.OPEN_NOTIFICATIONS, undefined);
          return;
        case SUPER_SEARCH_COMMANDS.START_GUIDED_TOUR:
          if (item.tourId) {
            onClose();
            onStartTour(item.tourId);
            return;
          }
          break;
        default:
          break;
      }

      onNavigate(item);
    },
    [onClose, onNavigate, onScopeItem, onStartTour, publish]
  );
};

export default useSuperSearchActions;
